export default {
      id: "payment-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#payment",
      toString: function () {
        return this.url;
      }
    }